import { Header } from "../components/site/Header";
import { Hero, HeroFinder } from "../components/site/Hero";
import { FirstVisit } from "../components/site/FirstVisit";
import { PriceTeaser } from "../components/site/PriceTeaser";
import { InquiryForm } from "../components/site/InquiryForm";
import { Reviews, CommunityBand } from "../components/site/HomeExtras";
import { Contact, Footer, MobileCta } from "../components/site/Footer";
import { SectionBoundary } from "../components/site/SectionBoundary";

// Hero · Erster Kurs · Kursfinder · Stimmen · Preise · Community & Team · Anfrage · Kontakt
export default function Home() {
  return (
    <div data-testid="home-page">
      <Header />
      <main>
        <SectionBoundary name="hero"><Hero /></SectionBoundary>
        <SectionBoundary name="firstvisit"><FirstVisit /></SectionBoundary>
        <SectionBoundary name="kursfinder"><HeroFinder /></SectionBoundary>
        <SectionBoundary name="reviews"><Reviews /></SectionBoundary>
        <SectionBoundary name="priceteaser"><PriceTeaser /></SectionBoundary>
        <SectionBoundary name="communityband"><CommunityBand /></SectionBoundary>
        <SectionBoundary name="inquiryform"><InquiryForm /></SectionBoundary>
        <SectionBoundary name="contact"><Contact visit={false} /></SectionBoundary>
      </main>
      <Footer />
      <MobileCta />
    </div>
  );
}
